<template lang="pug">
.start-stop-header(:class="{ 'start-stop-header-standard': !remoteVsOffice }")
  .start-stop-label-spacer(v-if="remoteVsOffice")
  .start-stop-scale(:style="{ gridTemplateColumns: `repeat(${labels.length}, minmax(0, 1fr))` }")
    span(
      v-for="(label, index) in labels"
      :key="index"
      :class="{ 'start-stop-hide-narrow': isNarrow && index % 2 === 1 }"
    ) {{ label }}
</template>

<script>
export default {
  name: 'InsightsStartStopTimeScaleHeader',
  props: {
    labels: {
      type: Array,
      required: true,
    },
    remoteVsOffice: {
      type: Boolean,
      required: true,
    },
    isNarrow: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
